"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfType = void 0;
var PdfType;
(function (PdfType) {
    PdfType["ania"] = "ANIA_ESTIMATE_PDF";
    PdfType["tractable"] = "TRACTABLE_ESTIMATE_PDF";
})(PdfType = exports.PdfType || (exports.PdfType = {}));
